import APIService from './APIService'

const api = APIService()

export const fetchAiProviderStatus = () => api.get('/me/ai-status')
